module.exports = __webpack_public_path__ + "static/media/DeviceMangIcon.4b8b63c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/DeviceMangIcon.svg
// module id = 1366
// module chunks = 0